import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {SchoolModel, SchoolsQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const SCHOOL_URL = `${API_URL}/school`

const getSchools = (query: string): Promise<SchoolsQueryResponse> => {
  return axios.get(`${SCHOOL_URL}?${query}`)
}

const createSchool = (school: SchoolModel): Promise<SchoolModel | undefined> => {
  return axios.post(SCHOOL_URL, school)
}

const updateSchool = (school: SchoolModel): Promise<SchoolModel | undefined> => {
  return axios.patch(`${SCHOOL_URL}`, school)
}

const deleteSchool = (schoolId: ID): Promise<void> => {
  return axios.delete(`${SCHOOL_URL}/${schoolId}`)
}
const getSchoolById = (id: ID): Promise<SchoolModel | undefined> => {
  return axios.get(`${SCHOOL_URL}/${id}`)
}

export {getSchools, deleteSchool, createSchool, updateSchool, getSchoolById}
